import { Injectable } from '@angular/core';
import { ConfigService, Script } from '../../config/config.service';

//export const ScriptStore: Scripts[] = [
//	{ name: 'jquery', src: 'http://d17vzy032wxsyj.cloudfront.net/jquery-slim.min.js' },
//	{ name: 'popper', src: 'http://d17vzy032wxsyj.cloudfront.net/popper.min.js' },
//	{ name: 'bootstrap', src: 'http://d17vzy032wxsyj.cloudfront.net/bootstrap.min.js' }
//];

declare var document: any;

@Injectable()
export class DynamicScriptLoaderService {

	private scripts: any = {};

	constructor(private config: ConfigService) { }

	getScripts(): Array<Script> {
		if (this.config.getConfig().scripts) {
			return this.config.getConfig().scripts.filter(x => !x.global);
		}
		return [];
	}

	load() {
		if (this.config.getConfig().scripts) {
			this.config.getConfig().scripts.forEach(x => this.scripts[x.name] = x);
			const promises: any[] = [];
			this.config.getConfig().scripts.filter(x => x.global).forEach((script) => promises.push(this.loadScript(script.name)));
			return Promise.all(promises);
		}
	}

	loadScript(name: string): Promise<any> {
		return new Promise((resolve, reject) => {
			if (this.scripts[name].loaded) {
				document.getElementsByTagName('head')[0].removeChild(this.scripts[name].tag);
			}
			// load script
			const script = document.createElement('script');
			script.setAttribute("id", name);
			script.type = 'text/javascript';
			script.src = this.scripts[name].src;
			this.scripts[name].tag = script;
			if (script.readyState) {  // IE
				script.onreadystatechange = () => {
					if (script.readyState === 'loaded' || script.readyState === 'complete') {
						script.onreadystatechange = null;
						this.scripts[name].loaded = true;
						resolve({ script: name, loaded: true, status: 'Loaded' });
					}
				};
			} else {  // Others
				script.onload = () => {
					this.scripts[name].loaded = true;
					resolve({ script: name, loaded: true, status: 'Loaded' });
				};
			}
			script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
			document.getElementsByTagName('head')[0].appendChild(script);
		});
	}

	importScript(name: string, path: string): Promise<any> {
		return new Promise((resolve, reject) => {
			if (document.getElementById(name) == null) {
				// load script
				const script = document.createElement('script');
				script.setAttribute("id", name);
				script.type = 'text/javascript';
				script.src = path;
				if (script.readyState) {  // IE
					script.onreadystatechange = () => {
						if (script.readyState === 'loaded' || script.readyState === 'complete') {
							script.onreadystatechange = null;
							script.loaded = true;
							resolve({ script: name, loaded: true, status: 'Loaded' });
						}
					};
				} else {  // Others
					script.onload = () => {
						script.loaded = true;
						resolve({ script: name, loaded: true, status: 'Loaded' });
					};
				}
				script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
				document.getElementsByTagName('head')[0].appendChild(script);
			}
			else {
				resolve({ script: name, loaded: true, status: 'Loaded' });
			}
		});
	}
}